import React, {
  MouseEvent,
  FunctionComponent,
  useEffect,
  useState,
} from "react";
import { Typography } from "@material-ui/core";
import "./index.scss";
import ContentItem from "components/content/ContentItem";
import { ContentPageItemCollection } from "services/entities/content";
import bg from "../../assets/img/steps/geo-1.svg";
import { Space } from "services/entities/spaces";

type SpaceFilterProps = {
  code: string;
  spaces: Space[] | null;
  filters: string[] | null;
  filterList: (location: string) => void;
};

type CityOccurance = Record<string, number>;

export const SpaceFilterSection: FunctionComponent<SpaceFilterProps> = ({
  code,
  spaces,
  filters,
  filterList,
}) => {
  const [spaceLocations, setSpaceLocations] = useState<CityOccurance>({});

  useEffect(() => {
    getSpaceLocations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spaces]);

  const getSpaceLocations = () => {
    const cities = spaces?.map((value) => value.city);
    const count = cities?.reduce<CityOccurance>(
      (acc: CityOccurance, city: string | null) => {
        if (city) {
          acc[city] = (acc[city] || 0) + 1;
        }
        return acc;
      },
      {}
    );
    if (count) {
      setSpaceLocations(count);
    }
  };

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const button: HTMLButtonElement = e.currentTarget;
    const location: string = button.value;
    filterList(location);
  };

  const toggleBackground = (city: string) => {
    return filters?.includes(city) ? "dark-background" : "light-background";
  };

  return (
    <section
      className="section--filter-spaces"
      style={{ backgroundImage: `url("${bg}")` }}
    >
      {code && (
        <ContentItem code={code}>
          {(item) => {
            return (
              <div className="header-content content-mw">
                <Typography variant="h1" component="h1" className="title">
                  {(item as ContentPageItemCollection).title.toString()}
                </Typography>
                <Typography
                  variant="body1"
                  component="p"
                  className="text"
                  dangerouslySetInnerHTML={{
                    __html: (item as ContentPageItemCollection).text.toString(),
                  }}
                />
              </div>
            );
          }}
        </ContentItem>
      )}
      <div className="filter-content content-mw">
        <div className="location-chips">
          {spaceLocations &&
            Object.keys(spaceLocations).map((space, index) => {
              return (
                <button
                  value={space}
                  key={index}
                  onClick={handleClick}
                  className={`location-chip ${toggleBackground(space)}`}
                >
                  {space} ({spaceLocations[space]})
                </button>
              );
            })}
        </div>
      </div>
    </section>
  );
};

export default SpaceFilterSection;
